"use strict";class r extends Error{constructor(r,s){super(r),this.name="SyntheticChangeError",this.cause=s}}module.exports=r;
